import { Paper, Typography } from "@material-ui/core";
import React from "react";
import { handleOrderColor } from "./handleOrderColor";
import { formatCustomDate } from "helpers/dateTools";
import { animations } from "helpers/animations";

export const styleShare = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  position: "relative",
  zIndex: 1,
};
export const OrderCard = (props) => {
  const { data, index } = props;
  const { total, date, unit, mappedStatus, account, customer } = data;

  const style = {
    padding: 4,
  };

  const styleStatus = {
    width: 15,
    height: 15,
    borderRadius: 50,
    backgroundColor: handleOrderColor(mappedStatus.color),
  };

  return (
    <Paper
    className={`${animations.fadeDown}`}
    style={{ ...style, animationDelay: `${index * 0.2}s` }}
    >
      <div style={styleShare}>
        <Typography variant="caption" color="primary">
          {unit} - {account}
        </Typography>
        <Typography variant="caption" bold>
          {formatCustomDate(date, "/")}
        </Typography>
      </div>
      <div style={styleShare}>
        <Typography variant="caption" color="primary">
          {customer}
        </Typography>
      </div>
      <div style={styleShare}>
        <Typography variant="caption" bold>
          {total}
        </Typography>
        <div style={{ ...styleShare, gap: 4 }}>
          <Typography variant="caption" bold>
            {mappedStatus.name}
          </Typography>
          <canvas style={styleStatus}></canvas>
        </div>
      </div>
    </Paper>
  );
};
